export default __webpack_public_path__ + "static/SourceSansPro-Italic-3c01996d38a55834ddcb5d102ec0b030.ttf";